<template>
  <div class="main-box">
    <p>完成的页面~</p>
    <ul>
      <li>0、特殊页面：解析后端返回值<span @click="goToPages(0)">Go!</span></li>
      <li>00、特殊页面：管理员登陆页面 <span @click="goToPages(74)">Go!</span></li>
      <li>1、(1-1)未登录状态首页<span @click="goToPages(1)">Go!</span></li>
      <li>
        2、(3-1)医疗机构登录状态首页<span @click="goToPages(2)">Go!</span>
      </li>
      <li>
        3、(3-4)教育机构登录状态首页<span @click="goToPages(3)">Go!</span>
      </li>
      <li>4、(2-2)登录页面<span @click="goToPages(4)">Go!</span></li>
      <li>5、(2-1)注册页面<span @click="goToPages(5)">Go!</span></li>
      <li>6、(4-1)医疗机构认证信息新增页面<span @click="goToPages(6)">Go!</span></li>
      <li>
        7、(4-3)医疗机构认证搜索页面<span @click="goToPages(7)">Go!</span>
      </li>
      <li>
        8、(4-6)教育机构认证搜索页面<span @click="goToPages(9)">Go!</span>
      </li>
      <li>
        9、(4-4)教育机构认证信息新增页面<span @click="goToPages(14)">Go!</span>
      </li>
      <li>
        10、(4-5)教育机构认证信息修改页面<span @click="goToPages(10)">Go!</span>
      </li>
      <li>
        11、(5-1)医疗机构信息查看页面<span @click="goToPages(8)">Go!</span>
      </li>
      <li>
        12、(5-3)教育机构信息查看页面<span @click="goToPages(11)">Go!</span>
      </li>
      <li>
        13、(5-5)医疗机构信息已认证信息修改页面<span @click="goToPages(12)"
          >Go!</span
        >
      </li>
      <li>
        14、(5-4)教育机关视角下 查看医疗机关主页<span @click="goToPages(13)"
          >Go!</span
        >
      </li>
      <li>15、(6-1)医疗机构员工管理<span @click="goToPages(15)">Go!</span></li>
      <li>16、(6-2)教育机构员工管理<span @click="goToPages(16)">Go!</span></li>
      <li>
        17、(5-6)医疗机构信息认证信息修改提示 审核中<span @click="goToPages(17)"
          >Go!</span
        >
      </li>
      <li>
        18、(5-11)教育机构信息认证信息修改提示 审核中<span
          @click="goToPages(18)"
          >Go!</span
        >
      </li>
      <li>
        19、(5-7)医疗机构信息认证信息修改提示 审核成功<span
          @click="goToPages(19)"
          >Go!</span
        >
      </li>
      <li>
        20、(5-10)教育机构信息认证信息修改提示 审核成功<span
          @click="goToPages(20)"
          >Go!</span
        >
      </li>
      <li>
        21、(5-8)医疗机构信息认证信息修改提示 审核失败<span
          @click="goToPages(21)"
          >Go!</span
        >
      </li>
      <li>
        22、(5-9)教育机构信息认证信息修改提示 审核失败<span
          @click="goToPages(22)"
          >Go!</span
        >
      </li>
      <li>
        23、(4-3-2)员工申请失败后 医疗机构认证搜索页面<span
          @click="goToPages(23)"
          >Go!</span
        >
      </li>
      <li>
        24、(5-2)医疗机构查看教育机构信息页面<span @click="goToPages(24)"
          >Go!</span
        >
      </li>
      <li>
        25、(6-3)教育机构查看岗位详情<span @click="goToPages(25)">Go!</span>
      </li>
      <li>
        26、(5-2-2)教育机构信息回复页面<span @click="goToPages(26)">Go!</span>
      </li>
      <li>
        27、(5-4-2)医疗机构信息回复页面<span @click="goToPages(27)">Go!</span>
      </li>
      <li>
        28、(6-3-2)医疗机构查看岗位消息 回复消息页面<span @click="goToPages(28)"
          >Go!</span
        >
      </li>
      <li>
        29、(7-5)用户医疗机构岗位添加页面进度1<span @click="goToPages(29)"
          >Go!</span
        >
      </li>
      <li>
        30、(7-3)教育机构人才添加进度1<span @click="goToPages(30)">Go!</span>
      </li>
      <li>
        31、(8-1)医疗机构岗位添加页面进度2<span @click="goToPages(31)"
          >Go!</span
        >
      </li>
      <li>
        32、(8-2)教育机构人才添加进度2<span @click="goToPages(32)">Go!</span>
      </li>
      <li>
        33、(9-1)医疗机构岗位添加页面进度3<span @click="goToPages(33)"
          >Go!</span
        >
      </li>
      <li>
        34、(7-4)教育机构添加招募者页面 从6-3跳转而来<span
          @click="goToPages(34)"
          >Go!</span
        >
      </li>
      <li>
        35、(12-1)医疗机构查看所有应聘者列表<span @click="goToPages(35)"
          >Go!</span
        >
      </li>
      <li>
        36、(12-3)教育机构应聘人才应聘案件显示列表<span @click="goToPages(36)"
          >Go!</span
        >
      </li>
      <li>
        37、(11-1)案件招募列表页面（应聘情况列表）<span @click="goToPages(37)"
          >Go!</span
        >
      </li>
      <li>
        38、(13-1)医疗机构收藏人才查看列表<span @click="goToPages(38)"
          >Go!</span
        >
      </li>
      <li>
        39、(13-2)教育机构案件收藏列表<span @click="goToPages(39)">Go!</span>
      </li>
      <li>
        40、(14-1)医疗机构收藏教育机构查看列表<span @click="goToPages(40)"
          >Go!</span
        >
      </li>
      <li>
        41、(12-4)教育机构案件应者查看界面<span @click="goToPages(41)"
          >Go!</span
        >
      </li>
      <li>
        42、(11-3)教育机构人才应聘情况查看列表<span @click="goToPages(42)"
          >Go!</span
        >
      </li>
      <li>43、管理员信息管理<span @click="goToPages(43)">Go!</span></li>
      <li>44、管理员员工管理<span @click="goToPages(44)">Go!</span></li>
      <li>45、管理员案件管理<span @click="goToPages(45)">Go!</span></li>
      <li>46、管理员所有应聘管理<span @click="goToPages(46)">Go!</span></li>
      <li>47、管理员人才管理<span @click="goToPages(47)">Go!</span></li>
      <li>
        48、管理员-教育机关查看列表ー编辑<span @click="goToPages(48)">Go!</span>
      </li>
      <li>
        49、(11-2)医疗机构人才信息查看公用界面管<span @click="goToPages(49)"
          >Go!</span
        >
      </li>
      <li>
        50、(10-3)医疗机构案件管理详情页面<span @click="goToPages(50)"
          >Go!</span
        >
      </li>
      <li>
        51、管理员-人才修改进度3<span @click="goToPages(51)">Go!</span>
      </li>
      <li>
        52、(14-2) 教育机构收藏医疗机构列表<span @click="goToPages(52)"
          >Go!</span
        >
      </li>
      <li>
        53、(10-2)教育机构人才列表查看界面<span @click="goToPages(53)"
          >Go!</span
        >
      </li>
      <li>
        54、(10-1) 医疗机构求人案件查看管理列表<span @click="goToPages(54)"
          >Go!</span
        >
      </li>
      <li>
        55、(15-1) 医疗机构案件进展情况详情页面<span @click="goToPages(55)"
          >Go!</span
        >
      </li>
      <li>
        56、(15-2) 教育机构应聘案件人员详情<span @click="goToPages(56)"
          >Go!</span
        >
      </li>
      <li>
        57、管理员-医疗机关查看列表ー编辑<span @click="goToPages(57)">Go!</span>
      </li>
      <li>
        58、管理员-医疗机关查看列表ー点看详情<span @click="goToPages(58)"
          >Go!</span
        >
      </li>
      <li>
        59、管理员-医疗机关员工管理<span @click="goToPages(59)">Go!</span>
      </li>
      <li>60、医疗机构消息查看页面<span @click="goToPages(60)">Go!</span></li>
      <li>61、教育机构消息查看页面<span @click="goToPages(61)">Go!</span></li>
      <li>62、承载中转页<span @click="goToPages(62)">Go!</span></li>
      <li>63、管理员-系统管理者<span @click="goToPages(63)">Go!</span></li>
      <li>64、管理员-应聘审核<span @click="goToPages(64)">Go!</span></li>
      <li>65、管理员-数据词典<span @click="goToPages(65)">Go!</span></li>
      <li>
        66、管理员-教育机构信息添加 <span @click="goToPages(66)">Go!</span>
      </li>
      <li>67、管理员-人才修改进度1<span @click="goToPages(67)">Go!</span></li>
      <li>68、管理员-人才修改进度2<span @click="goToPages(68)">Go!</span></li>
      <li>
        69、管理员-岗位添加页面进度1<span @click="goToPages(69)">Go!</span>
      </li>
      <li>
        70、管理员 医疗机构信息添加 <span @click="goToPages(70)">Go!</span>
      </li>
      <li>
        71、管理员 管理员岗位添加页面进度3
        <span @click="goToPages(71)">Go!</span>
      </li>
      <li>72、放弃管理员-数据面板 <span @click="goToPages(72)">Go!</span></li>
      <li>73、忘记密码页面 <span @click="goToPages(73)">Go!</span></li>
      <li>74、管理员登陆页面 <span @click="goToPages(74)">Go!</span></li>
      <li>75、管理员-教育机关查看列表ー点看详情<span @click="goToPages(75)">Go!</span></li>
      <li>76、管理员-单独某一机构医疗机关员工管理<span @click="goToPages(76)">Go!</span></li>
      <li>77、管理员-教育机关员工管理<span @click="goToPages(77)">Go!</span></li>
      <li>78、管理员-单独某一机构教育机关员工管理<span @click="goToPages(78)">Go!</span></li>
      <li>79、(7-1)管理员医疗机构岗位添加页面进度1 <span @click="goToPages(79)">Go!</span></li>
      <li>80、管理员医疗机构岗位添加页面进度2 <span @click="goToPages(80)">Go!</span></li>
      <li>81、管理员医疗机构岗位添加页面进度3 <span @click="goToPages(81)">Go!</span></li>
      <li>82、10-4 用户医疗机构求人案件自身信息列表<span @click="goToPages(82)">Go!</span></li>
      <li>83、13-3 医疗机构收藏应聘信息列表<span @click="goToPages(83)">Go!</span></li>
      <li>84、管理员应聘管理（某一案件下）<span @click="goToPages(84)">Go!</span></li>
      <li>85、管理员应聘管理（某一教育机构下）<span @click="goToPages(85)">Go!</span></li>
      <li>86、用户教育机构人才添加进度3 <span @click="goToPages(86)">Go!</span></li>
      <li>87、教育机构人管理员才添加进度1 <span @click="goToPages(87)">Go!</span></li>
      <li>88、教育机构管理员人才添加进度2 <span @click="goToPages(88)">Go!</span></li>
      <li>89、教育机构管理员人才添加进度3 <span @click="goToPages(89)">Go!</span></li>
      <li>90、医疗机构求人案件修改进度1 <span @click="goToPages(90)">Go!</span></li>
      <li>91、医疗机构求人案件修改进度2 <span @click="goToPages(91)">Go!</span></li>
      <li>92、医疗机构求人案件修改进度3 <span @click="goToPages(92)">Go!</span></li>
      <li>93、用户教育机构人才修改进度1<span @click="goToPages(93)">Go!</span></li>
      <li>94、用户教育机构人才修改进度2<span @click="goToPages(94)">Go!</span></li>
      <li>95、用户教育机构人才修改进度3<span @click="goToPages(95)">Go!</span></li>
      <li>96、10-5用户教育机构人才列表查看页面<span @click="goToPages(96)">Go!</span></li>
      <li>97、(10-1) 医疗机构求人案件查看管理列表 <span @click="goToPages(97)">Go!</span></li>
      <li>98、13-4 教育机构收藏应聘信息列表<span @click="goToPages(98)">Go!</span></li>
      <li>99、管理员-岗位添加页面进度2<span @click="goToPages(99)">Go!</span></li>
      <li>100、管理员-岗位添加页面进度3<span @click="goToPages(100)">Go!</span></li>
      <li>101、管理员-人才添加页面进度1<span @click="goToPages(101)">Go!</span></li>
      <li>102、管理员-人才添加页面进度2<span @click="goToPages(102)">Go!</span></li>
      <li>103、管理员-人才添加页面进度3<span @click="goToPages(103)">Go!</span></li>
      <li>104、管理员-岗位修改页面进度1<span @click="goToPages(104)">Go!</span></li>
      <li>105、管理员-岗位修改页面进度2<span @click="goToPages(105)">Go!</span></li>
      <li>106、管理员-岗位修改页面进度3<span @click="goToPages(106)">Go!</span></li>
      <li>107、管理员-收藏管理<span @click="goToPages(107)">Go!</span></li>

    </ul>
  </div>
</template>
<script>
export default {
  name: "allPagesName",
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    goToPages(num) {
      if (num === 1) {
        this.$router.push("/");
      } else if (num === 2) {
        this.$router.push("/medicalIndex");
      } else if (num === 3) {
        this.$router.push("/educateIndex");
      } else if (num === 4) {
        this.$router.push("/login");
      } else if (num === 5) {
        this.$router.push("/register");
      } else if (num === 6) {
        this.$router.push("/advancedCertification");
      } else if (num === 7) {
        this.$router.push("/medicalInstitution");
      } else if (num === 8) {
        this.$router.push("/medicalInstitutionInformation");
      } else if (num === 9) {
        this.$router.push("/educationalCertificationTable");
      } else if (num === 10) {
        this.$router.push("/educationalCertificationRevise");
      } else if (num === 11) {
        this.$router.push("/educationalInstitutionInformation");
      } else if (num === 12) {
        this.$router.push("/medicalCertificationModification");
      } else if (num === 13) {
        this.$router.push("/educationViewMedicalHomepage");
      } else if (num === 14) {
        this.$router.push("/educationalCertificationAdd");
      } else if (num === 15) {
        this.$router.push("/medicalStaffManagement");
      } else if (num === 16) {
        this.$router.push("/educationStaffManagement");
      } else if (num === 17) {
        this.$router.push("/underReview");
      } else if (num === 18) {
        this.$router.push("/educationUnderReview");
      } else if (num === 19) {
        this.$router.push("/reviewSucceeded");
      } else if (num === 20) {
        this.$router.push("/educationReviewSucceeded");
      } else if (num === 21) {
        this.$router.push("/auditFailure");
      } else if (num === 22) {
        this.$router.push("/educationAuditFailure");
      } else if (num === 23) {
        this.$router.push("/employeeApplicationFailed");
      } else if (num === 24) {
        this.$router.push("/medicalViewEducationHomepage");
      } else if (num === 25) {
        this.$router.push("/educationViewJobInformation");
      } else if (num === 26) {
        this.$router.push("/educationalInformationReply");
      } else if (num === 27) {
        this.$router.push("/medicalInformationReply");
      } else if (num === 28) {
        this.$router.push("/medicalJobInformationReply");
      } else if (num === 29) {
        this.$router.push("/medicalInstitutionJobCreationOne");
      } else if (num === 30) {
        this.$router.push("/educationTalentAddOne");
      } else if (num === 31) {
        this.$router.push("/medicalInstitutionJobCreationTwo");
      } else if (num === 32) {
        this.$router.push("/educationTalentAddTwo");
      } else if (num === 33) {
        this.$router.push("/medicalInstitutionJobCreationThree");
      } else if (num === 34) {
        this.$router.push("/educationalInstitutionAddRecruiter");
      } else if (num === 35) {
        this.$router.push("/medicalViewAllCandidates");
      } else if (num === 36) {
        this.$router.push("/educationalViewAllCases");
      } else if (num === 37) {
        this.$router.push("/medicalInstitutionCaseRecruitmentList");
      } else if (num === 38) {
        this.$router.push("/medicalInstitutionCollectionTalentsViewList");
      } else if (num === 39) {
        this.$router.push("/educationalInstitutionCaseCollectionList");
      } else if (num === 40) {
        this.$router.push("/medicalFavouritesEducationalInstitutionsViewList");
      } else if (num === 41) {
        this.$router.push("/educationInstitutionCaseResponderViewing");
      } else if (num === 42) {
        this.$router.push("/educationalInstitutionsTalentApplicationList");
      } else if (num === 43) {
        this.$router.push("/administratorInformationManagement");
      } else if (num === 44) {
        this.$router.push("/adminStaffManagement");
      } else if (num === 45) {
        this.$router.push("/administratorCaseManagement");
      } else if (num === 46) {
        this.$router.push("/administratorApplicationManagement");
      } else if (num === 47) {
        this.$router.push("/adminTalentManagement");
      } else if (num === 48) {
        this.$router.push("/administratorViewEducationalList");
      } else if (num === 49) {
        this.$router.push("/medicalInstitutionTalentInformationViewPublic");
      } else if (num === 50) {
        this.$router.push("/medicalInstitutionCaseManagementDetails");
      } else if (num === 51) {
        this.$router.push("/educationalInstitutionTalentRevisionProgress3");
      } else if (num === 52) {
        this.$router.push(
          "/educationalInstitutionCollectionMedicalInstitutionList"
        );
      } else if (num === 53) {
        this.$router.push("/educationalInstitutionTalentListView");
      }
      else if (num === 54) {
        this.$router.push("/administratorMedicalInstitutionRequestingCasesViewManagementList");
      }
      else if (num === 55) {
        this.$router.push("/detailsOfCaseProgressInMedicalInstitutions");
      } else if (num === 56) {
        this.$router.push(
          "/detailsOfApplicantsForCasesInEducationalInstitutions"
        );
      } else if (num === 57) {
        this.$router.push("/administratorsViewMedicalList");
      } else if (num === 58) {
        this.$router.push("/administratorsViewMedicalInstitutionsClickDetails");
      } else if (num === 59) {
        this.$router.push("/administratorsMedicalListStaffManagement");
      } else if (num === 60) {
        this.$router.push("/medicalInstitutionNewsView");
      } else if (num === 61) {
        this.$router.push("/educationInstitutionNewsView");
      } else if (num === 62) {
        this.$router.push("/transitBearer");
      } else if (num === 63) {
        this.$router.push("/administratorSystemAdministrator");
      } else if (num === 64) {
        this.$router.push("/administratorApplicationReviea");
      } else if (num === 65) {
        this.$router.push("/administratorDataDictionary");
      } else if (num === 66) {
        this.$router.push("/adminAddEducationalInstitutionInformation");
      } else if (num === 67) {
        this.$router.push("/educationalInstitutionTalentRevisionProgress1");
      } else if (num === 68) {
        this.$router.push("/educationalInstitutionTalentRevisionProgress2");
      } else if (num === 69) {
        this.$router.push("/adminPostAddPageProgressOne");
      } else if (num === 70) {
        this.$router.push("/administratorAddsMedicalInformation");
      } else if (num === 71) {
        this.$router.push("/administratorAzimuthAddPageProgress3");
      } else if (num === 72) {
        this.$router.push("/adminFrontPage");
      } else if (num === 73) {
        this.$router.push("/forgetPasswordEmailLink");
      } else if (num === 74) {
        this.$router.push("/loginAdmin");
      } else if (num === 75) {
        this.$router.push("/administratorsViewEducationInstitutionsClickDetails");
      } else if (num === 76) {
        this.$router.push("/administratorsOnlyMedicalListStaffManagement");
      } else if (num === 77) {
        this.$router.push("/administratorsEducationStaffManagement");
      } else if (num === 78) {
        this.$router.push("/administratorsOnlyEducationStaffManagement");
      } else if (num === 79) {
        this.$router.push("/medicalAdminInstitutionJobCreation1");
      } else if (num === 80) {
        this.$router.push("/medicalAdminInstitutionJobCreation2");
      } else if (num === 81) {
        this.$router.push("/medicalAdminInstitutionJobCreation3");
      } else if (num === 0) {
        this.$router.push("/decryptBackendReturnValue");
      } else if (num === 82) {
        this.$router.push("/userInformationListOfMedicalInstitutionsSeekingApplicants");
      } else if (num === 83) {
        this.$router.push("/medicalInstitutionsCollectApplicationInformationList");
      } else if (num === 84) {
        this.$router.push("/administratorApplicationManagementOnlyCase");
      } else if (num === 85) {
        this.$router.push("/administratorApplicationManagementOnlyEducation");
      } else if (num === 86) {
        this.$router.push("/educationTalentAddThree");
      } else if (num === 87) {
        this.$router.push("/educationAdminTalentAddOne");
      } else if (num === 88) {
        this.$router.push("/educationAdminTalentAddTwo");
      } else if (num === 89) {
        this.$router.push("/educationAdminTalentAddThree");
      } else if (num === 90) {
        this.$router.push("/medicalInstitutionJobReviseOne");
      } else if (num === 91) {
        this.$router.push("/medicalInstitutionJobReviseTwo");
      } else if (num === 92) {
        this.$router.push("/medicalInstitutionJobReviseThree");
      } else if (num === 93) {
        this.$router.push("/userEducationInstitutionsToModifyTheSchedule1");
      }else if (num === 94) {
        this.$router.push("/userEducationInstitutionsToModifyTheSchedule2");
      }else if (num === 95) {
        this.$router.push("/userEducationInstitutionsToModifyTheSchedule3");
      } else if (num === 96) {
        this.$router.push("/userEducationalInstitutionTalentListView");
      } else if (num === 97) {
        this.$router.push("/administratorMedicalInstitutionRequestingCasesViewManagementList");
      } else if (num === 98) {
        this.$router.push("/educationalInstitutionsCollectApplicationInformationList");
      } else if (num === 99) {
        this.$router.push("/adminPostAddPageProgressTwo");
      } else if (num === 100) {
        this.$router.push("/adminPostAddPageProgressThree");
      } else if (num === 101) {
        this.$router.push("/adminTalentAdd1");
      } else if (num === 102) {
        this.$router.push("/adminTalentAdd2");
      } else if (num === 103) {
        this.$router.push("/adminTalentAdd3");
      } else if (num === 104) {
        this.$router.push("/adminJobRevise1");
      } else if (num === 105) {
        this.$router.push("/adminJobRevise2");
      } else if (num === 106) {
        this.$router.push("/adminJobRevise3");
      }  else if (num === 107) {
        this.$router.push("/adminCollectionManagement");
      }
    },
  },
};
</script>
<style scoped>
.main-box {
  background: #fff;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}
.main-box p {
  width: 1200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 20px;
}
.main-box li {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-bottom: 10px;
  box-shadow: 0 8px 8px rgba(10, 16, 20, 0.24), 0 0 8px rgba(10, 16, 20, 0.12);
  display: block;
}
.main-box span {
  margin-left: 20px;
  font-weight: 700;
  color: red;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/allPagesName/index.vue